import ExtendableError from '../base/extendable_error';

/**
 *
 *
 *
 */
class OverlayException extends ExtendableError {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'OverlayException';


    /**
     * @static
     * @param params
     * @returns {ExtendableError}
     */
    static create(params) {
        return super.create(params);
    }
}


export default (params) => {
    return OverlayException.create(params);
}